import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

export function FreeTerminForm({ value, onChange, monteure }) {
  const set = (k) => (e) => onChange({ ...value, [k]: e?.target ? e.target.value : e });
  return (
    <div className="space-y-4" data-testid="pt-frei-form">
      <div className="space-y-1.5">
        <Label>Titel *</Label>
        <Input value={value.titel} onChange={set("titel")} placeholder="z. B. Lager aufräumen, Schulung, Besichtigung" required maxLength={120} data-testid="pt-frei-titel" />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-1.5">
          <Label>Datum *</Label>
          <Input type="date" value={value.datum} onChange={set("datum")} required data-testid="pt-frei-datum" />
        </div>
        <div className="space-y-1.5">
          <Label>bis (optional)</Label>
          <Input type="date" value={value.datum_ende} onChange={set("datum_ende")} data-testid="pt-frei-datum-ende" />
        </div>
        <div className="space-y-1.5">
          <Label>Uhrzeit von</Label>
          <Input type="time" value={value.uhrzeit_von} onChange={set("uhrzeit_von")} data-testid="pt-frei-zeit-von" />
        </div>
        <div className="space-y-1.5">
          <Label>Uhrzeit bis</Label>
          <Input type="time" value={value.uhrzeit_bis} disabled={!value.uhrzeit_von} onChange={set("uhrzeit_bis")} data-testid="pt-frei-zeit-bis" />
        </div>
      </div>
      <div className="space-y-1.5">
        <Label>Monteur</Label>
        <Select value={value.monteur_id || "none"} onValueChange={(v) => onChange({ ...value, monteur_id: v === "none" ? "" : v })}>
          <SelectTrigger data-testid="pt-frei-monteur"><SelectValue placeholder="—" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="none">— kein Monteur —</SelectItem>
            {monteure.map((m) => <SelectItem key={m.id} value={m.id}>{m.name || m.email}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1.5">
        <Label>Notiz</Label>
        <Textarea rows={3} value={value.notiz} onChange={set("notiz")} maxLength={2000} data-testid="pt-frei-notiz" />
      </div>
    </div>
  );
}
